import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ApiKeys } from '../features/api-keys';
import useAppStore from '../store/rootStore.ts';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/apikeys')({
  component: ApiKeysRouteComponent,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.apiKeysEnabled) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const apiKeysPageSx = createPageBackgroundSx();

function ApiKeysRouteComponent() {
  return (
    <Stack sx={apiKeysPageSx}>
      <ApiKeys />
    </Stack>
  );
}
